import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCurrentUser } from '@/hooks';

import type { PropsWithChildren } from 'react';

import LoadingCover from '@/components/Layouts/Loading';
import { isAdmin } from '@/types/user';

const RequireAdmin = ({ children }: PropsWithChildren) => {
  const { user, isUserLoading } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isUserLoading && (!user.id || !isAdmin(user))) {
      navigate('/coach/manage', { replace: true });
    }
  }, [isUserLoading, navigate, user]);

  if (isUserLoading) return <LoadingCover />;

  return isAdmin(user) ? children : null;
};

export default RequireAdmin;
